import React, { useState } from "react";
import { Button, Pagination, Input, List, Skeleton, Modal, Divider } from 'antd';
import axios from 'axios';
import BackOfficeExpenseModal from "./modal.expsense";
import { requestError } from "../../controllers/functions";
import moment from "moment";

const BackOfficeExpenses = ({ setSearchString, expnses, loading, refresh, currentPage, setCurrentPage, pageSize, extractTokenFromUrl }) => {
  
  const [ opeExpenseModal , setOpeExpenseModal ] = useState(false);
  const [ expense , setExpense ] = useState(false);

const deleteExpense = React.useCallback((id) => {
    axios.delete(process.env.REACT_APP_API_URI+`/back/office/expenses/${id}`, {headers: { authorization : `Bearer ${extractTokenFromUrl()}`}}).then(data =>{
      refresh();
    }).catch(error =>{
      requestError({error})
    })
  }, [extractTokenFromUrl, refresh]);

return <>
  <div
    style={{
      display: "flex",
      justifyContent: "center", // centers horizontally
      alignItems: "center", // centers vertically
      gap: 10, // space between title and input
      marginBottom: 10,
      justifyContent: "space-between",
    }}
  >
    <h3 style={{ fontSize: 13, margin: 0 }}>Expenses</h3>
    <span style={{ display : "flex", alignItems : "center", gap : 1 }}>
      <Input
        style={{ height: 29, minWidth: 100, marginRight: 5 }}
        placeholder="Search Expense"
        onChange={(e) => {
          setSearchString(e.target.value);
          setCurrentPage(1);
        }}
      />
      <Button
      style={{
        height: 29
      }}
      onClick={ ()=>{
            setOpeExpenseModal(true);
            setExpense({});
        }}
      > + </Button>
    </span>
  </div>

  <Divider />

  <List
    dataSource={expnses.expenses || []}
    loading={loading}
    renderItem={(item) => (
      <List.Item
        actions={[
          <a key="list-loadmore-edit" style={{ fontSize: 11.5 }}>
           {item?.currency?.name} {parseFloat(item?.amount).toFixed(2)}
          </a>,
        ]}
        style={{ fontSize: 13 }}
      >
        <Skeleton avatar title={false} loading={item?.loading} active>
          <List.Item.Meta
            title={
              <a href="#" style={{ fontSize: 12 }}>
                {moment(item?.date).format("ddd[,] DD")}  - {item?.expenseType?.name}
              </a>
            }
            description={
              <div style={{ color: "#888" }}>

                <div style={{ fontSize: 12, display : "flex", gap : 10 }}>
                  <div>
                    <span style={{ fontWeight : 600 }}>{ item?.notes || "No notes provided"}</span>
                  </div>
                  
                </div>

                <div style={{ marginTop: "0.6rem" }}>

                  <Button
                    size="small"
                    type="link"
                      onClick={ ()=>{
                          setOpeExpenseModal(true);
                          setExpense(item);
                      }}
                      style={{ color : "#050505"}}
                  >
                    <span style={{ fontSize: 11 }}> Edit </span>
                  </Button>

                  <Button
                    size="small"
                    type="link"
                    onClick={() => {
                      Modal.confirm({
                        title: "Are you sure you want to delete this?",
                        onCancel: () => {},
                        onOk: () => deleteExpense(item?.id),
                      });
                    }}
                    danger
                  >
                    <span style={{ fontSize: 11 }}>Delete</span>
                  </Button>
                </div>
              </div>
            }
          />
        </Skeleton>
      </List.Item>
    )}
  />

  {/* Pagination */}
  {expnses?.total > pageSize && (
    <div style={{ textAlign: "right", marginTop: "1rem" }}>
      <Pagination
        current={currentPage}
        pageSize={pageSize}
        total={expnses?.total}
        onChange={(page) => setCurrentPage(page)}
        size="small"
      />
    </div>
  )}


      <div style={{ paddingLeft : "1rem", paddingRight : "1rem"}}>

        <BackOfficeExpenseModal
            show={opeExpenseModal}
            setOpenModal={setOpeExpenseModal}
            refresh = {refresh}
            extractTokenFromUrl={extractTokenFromUrl}
            record={expense}
        />

      </div>
      
  </>
}



export default BackOfficeExpenses;